import * as React from "react";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import {Option} from "ts-option";
import User from "../../../model/user/User";
import SelectUsers from "../watchers/SelectUsers";
import {DisableableProps} from "../../common/props/DisableableProps";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";

interface IComponentProps {
	/**
	 * Filters users available to be selected.
	 * @param {User} user
	 * @returns {boolean}
	 */
	filterFunction?: (user: User) => boolean;
}

interface ReduxProps {
	/**
	 * Users available to be selected.
	 */
	users: Option<User[]>;
}

type Props = FormGroupProps<string[]> & PlaceholderProps & DisableableProps & IComponentProps & ReduxProps;

/**
 * Select users form view group.
 */
class SelectUsersFormGroup extends React.PureComponent <Props, {}> {
	constructor(props: Props) {
		super(props);
		this.onChange = this.onChange.bind(this);
	}

	render() {
		return (
			<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
				<SelectUsers placeholder={this.props.placeholder}
							 selectedId={this.props.field.getOptionalValue()}
							 onChanged={this.onChange}
							 items={this.props.users}
							 multi={true}
							 disabled={this.props.disabled}/>
			</FormGroup>
		);
	}

	/**
	 * Callback on changed user.
	 * @param data
	 */
	onChange(data: Option<User[]>) {
		this.props.onChange(this.props.field.updateValue(data.map(d => d.map(u => u.id))))
	}
}

function mapStateToProps(state: RootState, props: IComponentProps) {
	let users = state.user.users;
	if (props.filterFunction) {
		users = users.map(u => u.filter(props.filterFunction));
	}
	return {users}
}

export default connect(mapStateToProps)(SelectUsersFormGroup);
